import { User } from "oidc-client-ts";
import { useITwinEventsServiceV1API } from "../useITwinEventsServiceV1API/useITwinEventsServiceV1API";

export const useGovernanceController = <T,>(
  user?: User,
  cacheResponse: boolean = true
) => {
  return useITwinEventsServiceV1API<T>("governance", cacheResponse);
};
